import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { LeaseAgreementService } from '../data/lease-agreement.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Contract } from '../../model/contract';

@Injectable()
export class PrintContractTerminationFormCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: LeaseAgreementService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === leaseAgreementCommand.printTerminationForm && command.context;
  }
  execute(command: Command): Observable<void> {
    if (command instanceof Command) {
      return this._dataService
        .getTerminationForm(command.context.id)
        .pipe(map(res => this._nativeWindow.openFile(res, `${(<Contract>command.context).leaseAgreementNumber}.pdf`)));
    }
  }
}
